import { useCallback, useEffect, useState } from "react";
import { Item } from "../types";
import getItem from "../api/itemApi";

export default function useItem(id:string) {
  const [item, setItemList] = useState<Item>();

  const get = useCallback(async () => {
    try {
      const res = await getItem(id);
      if(res){
        setItemList(res)
      }
    }catch(error){
      console.error("error", error);
    }
  }, [])

  useEffect(() => {
    (async () => {
      await get();
    })();
  }, []);

  return [{item}, { get }] as const;
}